import { Directive, ElementRef, Renderer2, OnInit, OnDestroy } from '@angular/core';
import { NotificationService } from '../_services/notification.service';
import { Subscription } from 'rxjs';
import { NotificationData } from '../_models/notification.model';

@Directive({
    selector: '[appNotificationQueue]',
    standalone: false
})
export class NotificationQueueDirective implements OnInit, OnDestroy {
  private queue: NotificationData[] = [];
  private isProcessing = false;
  private subscription!: Subscription;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    // Écoute les notifications du service
    this.subscription = this.notificationService.notifications$.subscribe(
      (notification) => {
        this.queue.push(notification);
        if (!this.isProcessing) {
          this.processQueue();
        }
      }
    );
  }

  private async processQueue() {
    this.isProcessing = true;

    while (this.queue.length > 0) {
      const currentNotification = this.queue.shift();
      if (currentNotification) {
        await this.showNotification(currentNotification);
      }
    }

    this.isProcessing = false;
  }

  private showNotification(notification: NotificationData): Promise<void> {
    return new Promise((resolve) => {
      const notificationDiv = this.renderer.createElement('div');
      const icon = this.renderer.createElement('i');
      const text = this.renderer.createText(notification.message);

      if (notification.type === 'alert') {
        this.renderer.addClass(notificationDiv, 'notif');
        this.renderer.addClass(notificationDiv, 'alert');
        this.renderer.addClass(icon, 'fa-solid');
        this.renderer.addClass(icon, 'fa-triangle-exclamation');
      } else if (notification.type === 'success') {
        this.renderer.addClass(notificationDiv, 'notif');
        this.renderer.addClass(notificationDiv, 'success');
        this.renderer.addClass(icon, 'fa-regular');
        this.renderer.addClass(icon, 'fa-circle-check');
      } else if (notification.type === 'warning') {
        this.renderer.addClass(notificationDiv, 'notif');
        this.renderer.addClass(notificationDiv, 'warning');
        this.renderer.addClass(icon, 'fa-regular');
        this.renderer.addClass(icon, 'fa-circle-check');
      }

      this.renderer.appendChild(notificationDiv, icon);
      this.renderer.appendChild(notificationDiv, text);
      this.renderer.appendChild(this.el.nativeElement, notificationDiv);

      setTimeout(() => {
        this.renderer.removeChild(this.el.nativeElement, notificationDiv);
        resolve();
      }, 5000);
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
